module.exports = __webpack_public_path__ + "img/3.f6de7aa0.png";